import Login from '../pages/login/index';
import IndexApp from '../pages/index/index';
import RegisterList from '../pages/userInfo/registerList';
import Map from "../pages/dataMap/index";
const RouterList = [
  { path: "/product", element: <IndexApp /> },
  { path: "/login", element: <Login /> },
  { path: "/userInfo", element: <RegisterList /> },
  { path: "/", element: <Map /> },
]

export default RouterList;
